export default {
  styleOverrides: {
    paper: {
      backgroundColor: 'var(--color-bg-paper)',
      borderRadius: '12px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
    }
  },
};
